import moment from "moment";

export const DISCREPANCY_STATES = [
  "discrepancies",
  "discrepancy_GB_GB",
  "discrepancy_GB_Company",
  "discrepancy_GB_Employee",
];

const isDiscrepancyState = (state) =>
  DISCREPANCY_STATES.includes(state) ||
  (typeof state === "string" && state.toLowerCase().includes("descrep"));

/** True when an approved app is due for renewal within the next 15 days. */
export const isRenewalDueSoon = (item) => {
  if (!item?.due_date) return false;
  if (item.state !== "approved" && item.state !== "renewal") return false;
  const due = moment(item.due_date);
  if (!due.isValid()) return false;
  return (
    due.isSameOrAfter(moment().startOf("day")) &&
    due.isSameOrBefore(moment().add(15, "days").endOf("day"))
  );
};

/** Calculate dashboard statistics from a full applications list. */
export const calculateApplicationCounts = (applications = []) => {
  const list = Array.isArray(applications) ? applications : [];

  let newApplications = 0;
  let pendingFromDW = 0;
  let discrepencies = 0;
  let approved = 0;
  let renewal = 0;

  list.forEach((item) => {
    const state = item?.state;

    if (state === "in_process") newApplications += 1;
    else if (state === "pending_for_approval" || state === "pending")
      pendingFromDW += 1;
    else if (isDiscrepancyState(state)) discrepencies += 1;
    else if (state === "approved") approved += 1;

    if (state === "renewal" || isRenewalDueSoon(item)) renewal += 1;
  });

  return {
    newApplications,
    pendingFromDW,
    discrepencies,
    approved,
    renewal,
  };
};
